import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import config from './config'
import lodash from './utils/lodash'
import api from './utils/api'
import request from './utils/request'
import request_api from './utils/request.api'
import request_pedigree from './utils/request.pedigree'
import calendar from './utils/calendar'
import dynamicLoadScript from './utils/dynamicLoadScript'
import './icons'
import './public'
import './permission'
import './styles/index.scss'
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)

Vue.config.productionTip = false
Vue.prototype.$FILE_PATH = config.RESOURCE_PATH
Vue.prototype.$lodash = lodash
Vue.prototype.$api = api
Vue.prototype.$request = {}
Vue.prototype.$request.common = request
Vue.prototype.$request.api = request_api
Vue.prototype.$request.pedigree = request_pedigree
Vue.prototype.$calendar = calendar
Vue.prototype.$dynamicLoadScript = dynamicLoadScript

const vue = new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')

export default vue
